<script lang="ts">
    import L from "leaflet";
    import { onMount } from "svelte";
    import type { NetworkResponse } from "../../../../../../admin-service-typescript-client";
    import { ApiClient } from "../../../../../GlobalHelper/ApiClient";
    import { user } from "../../../../../store/stores";

    export let network: NetworkResponse;

    let geoData;
    let map;

    async function getLocations() {
        await ApiClient.getInstance($user)
            .locationClient.listGeoLocationsOfAllLocations({})
            .then((locationsGeoData) => {
                const markers = L.markerClusterGroup();
                geoData = locationsGeoData;
                locationsGeoData
                    .filter((location) => location.networkId === network.id)
                    .forEach((geoData) => {
                        if (
                            geoData.geoLocation?.latitude &&
                            geoData.geoLocation?.longitude
                        )
                            markers.addLayer(
                                L.marker([
                                    geoData.geoLocation.latitude,
                                    geoData.geoLocation.longitude,
                                ])
                            );
                    });
                map.addLayer(markers);
            });
    }

    const initialView = [52.8283, 9.5795];
    function createMap(container) {
        map = L.map(container, { preferCanvas: true }).setView(initialView, 5);
        let k = L.tileLayer(
            "https://{s}.basemaps.cartocdn.com/rastertiles/voyager/{z}/{x}/{y}{r}.png",
            {
                attribution: `&copy;<a href="https://www.openstreetmap.org/copyright" target="_blank">OpenStreetMap</a>,
	        &copy;<a href="https://carto.com/attributions" target="_blank">CARTO</a>`,
                subdomains: "abcd",
                maxZoom: 14,
            }
        );
        console.log(L);
        // L.getLayer.getPane().style.zIndex = 10;
        k.addTo(map);

        return map;
    }
    onMount(() => {
        console.log("start");
        getLocations();
        console.log("end");
    });
    function mapAction(container) {
        map = createMap(container);
        map;

        return {
            destroy: () => {
                map.remove();
                map = null;
            },
        };
    }

    // L.marker([51.5, -0.09]).addTo(mymap);
</script>

<div class="card network-details ">
    <div class="card-content no-padding">
        <div class="content map">
            <link
                rel="stylesheet"
                href="https://unpkg.com/leaflet@1.6.0/dist/leaflet.css"
                integrity="sha512-xwE/Az9zrjBIphAcBb3F6JVqxf46+CDLwfLMHloNu6KEQCAWi6HcDUbeOfBIptF7tcCzusKFjFw2yuvEpDL9wQ=="
                crossorigin=""
            />
            <div class="map" style="height:100%;width:100%" use:mapAction />
        </div>
    </div>
</div>

<style>
    .map {
        padding: 0;
        height: 25vw;
        max-height: 25rem;
    }
    .no-padding {
        padding: 0;
    }
</style>
